import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router"
import { z } from "zod"

import {
  adtTriggerRulesQueryOptions,
  type AdtTriggerRulesListQuery,
} from "@/features/adt-trigger-rules/queries"

const adtTriggerRulesSearchSchema = z.object({
  facility: z.coerce.number().optional().catch(undefined),
  triggerType: z.enum(["adt_event", "chatbot_alert"]).optional().catch(undefined),
  page: z.coerce.number().catch(1),
  pageSize: z.coerce.number().catch(10),
})

export const Route = createFileRoute("/_app/manage/adt-trigger-rules/")({
  validateSearch: (search: SearchSchemaInput) =>
    adtTriggerRulesSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => {
    const query: AdtTriggerRulesListQuery = {
      page: deps.page,
      pageSize: deps.pageSize,
      ...(deps.facility !== undefined ? { facility: deps.facility } : {}),
      ...(deps.triggerType !== undefined ? { triggerType: deps.triggerType } : {}),
    }
    return context.queryClient.ensureQueryData(adtTriggerRulesQueryOptions(query))
  },
})
